import { SubMenuList } from '../SubMenuList'

import * as styles from './SubMenuFoldersSection.module.css'

function SubMenuFoldersSection({
  className = styles.SubMenuFoldersSection,
  ...restProps
}) {
  return (
    <div className={className}>
      <SubMenuList {...restProps} />
    </div>
  )
}

export default SubMenuFoldersSection
